import { CustomQueryOptions } from '@/types/query';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listSSHInstances, terminateSSHInstance } from '.';
import { SSHInstance } from './type';
import { useGPUInstanceStore } from '@/store/gpu-instance';

const keyname = 'gpu-instance';

export const useListSSHInstances = (
  option?: CustomQueryOptions<SSHInstance[]>
) => {
  const { token } = useGPUInstanceStore();

  return useQuery({
    queryKey: [keyname, 'ssh-list'],
    queryFn: async () => {
      if (!token) {
        throw new Error('No token available');
      }
      const response = await listSSHInstances(token);
      return response.instances;
    },
    enabled: !!token,
    ...option,
  });
};

export const useTerminateSSHInstance = () => {
  const { token } = useGPUInstanceStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (taskId: string) => {
      if (!token) {
        throw new Error('No token available');
      }
      return terminateSSHInstance(taskId, token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [keyname, 'ssh-list'] });
    },
  });
};
